import { sortingTypes } from "./sorting";
import { chartListRequests } from "./chartListRequests/chartListRequests";
import { Api } from "../../api/api";
import processCustomCollection from "./processCustomCollection";

import {
  filterTestCollections,
  addCollectionType,
  DEFAULT_COLLECTIONS,
} from "./collectionList";

export class CollectionUtils {
  static async getChartCollections() {
    const { chart_collections } = await Api.getChartCollections();
    const filteredList = filterTestCollections(chart_collections);
    const populatedChartList = addCollectionType(filteredList);

    return [...DEFAULT_COLLECTIONS, ...populatedChartList];
  }
  static sortCharts(list, sorting) {
    const sortingType = sortingTypes[sorting];
    const sortedCharts = sortingType.method(list, sortingType.property);
    return sortedCharts;
  }
  static filterNamesByFilterArray(list, filters) {
    if (!filters.length) return list;
    return list.filter((item) =>
      filters.some((filter) => item.name.includes(filter))
    );
  }
  static filterNamesByText(list, text) {
    if (!text) return list;
    return list.filter((chart) =>
      chart.name.toLowerCase().includes(text.toLowerCase())
    );
  }
  static async getChartList(collection) {
    if (!collection) return [];

    if (collection.type === "custom") {
      const aggregatedChartList = await processCustomCollection(collection);

      return aggregatedChartList;
    } else {
      const request = chartListRequests[collection.type];
      const chartList = await request(collection.id);

      return chartList;
    }
  }
}
